import React from 'react';
import { faScribble } from '@fortawesome/pro-regular-svg-icons/faScribble';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ScribbleRegularIcon(props) {
  return <FontAwesomeIcon icon={faScribble} {...props} />;
}
